import React from "react";
import { motion } from "framer-motion";
import {
  Crosshair,
  Eyes,
  HandWithdraw,
  Headset,
  Sparkle,
} from "@phosphor-icons/react";

const PRO_FEATURES = [
  {
    title: "PRO Badge",
    description: "Help homeowners identify trusted professionals with the PRO badge.",
    Icon: Sparkle,
    iconWeight: "fill",
    iconColor: "#111111",
  },
  {
    title: "Higher Visibility",
    description: "Increase profile visibility & stay ahead of other professionals at HYNT.",
    Icon: Eyes,
  },
  {
    title: "Receive Inquiries",
    description: "Receive project inquiries directly from interested homeowners on HYNT.",
    Icon: HandWithdraw,
  },
  {
    title: "Access to Open leads",
    description:
      "Access homeowner requirements & connect with users actively seeking professional services.",
    Icon: Crosshair,
  },
  {
    title: "Priority Support",
    description: "Receive priority support to help your business move faster.",
    Icon: Headset,
    iconWeight: "fill",
  },
];

const listMotion = {
  hidden: { opacity: 0, y: 26 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: "easeOut",
      staggerChildren: 0.12,
      delayChildren: 0.08,
    },
  },
};

const itemMotion = {
  hidden: { opacity: 0, y: 22 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

function RevampProfessionalsPro() {
  return (
    <section className="revamp-section-shell revamp-pro-shell" aria-label="HYNT PRO">
      <div className="revamp-pro-grid">
        <div className="revamp-pro-left" aria-label="HYNT PRO benefits">
          <motion.ul
            className="revamp-pro-list"
            variants={listMotion}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            {PRO_FEATURES.map((item) => (
              <motion.li key={item.title} className="revamp-pro-item" variants={itemMotion}>
                <div className={`revamp-pro-icon ${item.accent ? "is-accent" : ""}`} aria-hidden="true">
                  <item.Icon
                    size={22}
                    weight={item.iconWeight ?? "regular"}
                    color={item.iconColor}
                  />
                </div>
                <div className="revamp-pro-copy">
                  <h3 className={item.accent ? "is-accent" : ""}>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </motion.li>
            ))}
          </motion.ul>
        </div>

        <div className="revamp-pro-right">
          <div className="revamp-pro-eyebrow">Be at an advantage</div>
          <h2 className="revamp-pro-heading">
            Grow faster.
            <br />
            with <span className="revamp-pro-accent">HYNT PRO.</span>
          </h2>
          <p className="revamp-pro-subcopy">
            What&apos;s already good, made better with an additional tool stack.
          </p>
        </div>
      </div>
    </section>
  );
}

export default RevampProfessionalsPro;

